export default __webpack_public_path__ + "static/media/eucalipto.25b85981.png";